import { Component, Input } from '@angular/core';
import * as moment from 'moment/moment';


@Component({
  moduleId: module.id,
  selector: 'upload-progress',
  templateUrl: 'upload-progress.component.html',
  styleUrls: ['upload-progress.component.scss'],
})
export class UploadProgressComponent {
  @Input() uploadProgressPercent: number = 0;
  @Input() uploadProgressSeconds: number = 0;

  get formatProgressTime(): string {
    const time = moment.utc(moment.duration(this.uploadProgressSeconds, 'seconds').asMilliseconds());
    const hours = time.get('hours');
    const minutes = time.get('minutes');
    const seconds = time.get('seconds');

    return (hours ? `${hours} ${this.getSuffix('hour', hours)} ` : '') +
           (minutes ? `${minutes} ${this.getSuffix('minute', minutes)} ` : '') +
           (seconds ? `${seconds} ${this.getSuffix('second', seconds)}` : '');
  }

  private getSuffix(noun: string, count: number): string {
    return count === 1 ? noun : `${noun}s`;
  }

}
